export default "__VITE_ASSET__Bt3Q591t__"